/*
  This file is part of the project: "Digiziege"
  An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
  GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

  Copyright (c) 2026 Digiziege Team TH-Bingen

  Description:
  Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
  master data management and health tracking.
  Built as a PWA with a local-first approach to ensure data privacy.

  LICENSE INFORMATION:
  This program is free software: you can redistribute it and/or modify it under the terms of the
  GNU Affero General Public License as published by the Free Software Foundation,
  either version 3 of the License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
  without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
  See the GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License along with this program.
  If not, see <https://www.gnu.org/licenses/>.
*/

import { groupRepository } from '@/services/repositories/group.repository.js';

/**
 * Group Seeder
 * Creates dummy group data for development
 */

const DUMMY_HERDS = [
  {
    name: 'Mountain Group',
    location: 'North Pasture',
    description: 'Main breeding group located in the mountain pasture'
  },
  {
    name: 'Valley Group',
    location: 'South Pasture',
    description: 'Young goats and yearlings in the valley area'
  },
  {
    name: 'Alpine Group',
    location: 'East Pasture',
    description: 'Alpine goats specializing in milk production'
  },
  {
    name: 'Barn A',
    location: 'Main Barn',
    description: 'Indoor group for winter season'
  },
  {
    name: 'Breeding Group',
    location: 'West Pasture',
    description: 'Selected breeding stock'
  }
];

/**
 * Seed groups into the database
 * @returns {Promise<Array<number>>} Array of created group IDs
 */
export async function seedGroups() {
  console.log('Seeding groups...');
  const groupIds = [];

  try {
    for (const group of DUMMY_HERDS) {
      const id = await groupRepository.create(group);
      groupIds.push(id);
      console.log(`  Created group: ${group.name} (ID: ${id})`);
    }

    console.log(`Seeded ${groupIds.length} groups`);
    return groupIds;
  } catch (error) {
    console.error('Failed to seed groups:', error);
    throw error;
  }
}
